<section class="auth-form">
  <h1 *ngIf="showTitle">Login</h1>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" (keydown.enter)="submitFromEnter($event)" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="password" (keydown.enter)="submitFromEnter($event)" />
    </mat-form-field>
    <div class="actions">
      <button mat-raised-button color="primary" type="submit">Login</button>
      <a routerLink="/forgot" mat-button>Forgot password?</a>
    </div>
    <p class="info" *ngIf="info() as i">{{ i }}</p>
    <p class="error" *ngIf="error() as e">{{ e }}</p>
  </form>
</section>
